import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload, faTrash, faCheck } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const UploadInput = ({
    handleUploadArquivos,
    handleDownloadArquivo,
    handleRemoverArquivo,
    id,
    label,
    aprovado = null,
    situacaoSolic,
    register,
    registerName,
    obrigatorio,
    codigoDocumento,
    codigoIdDoc,
    disabled,
    nomeArquivo = "",
    origemSolicitacao,
    criterioAutoConsumo,
    criterioMultiUC,
    criterioGeracaoComp,
    criterioCompensacaoLocal,
    criterioAereo,
    criterioSubterraneo,
    criterioMinigeracao,
    criterioMicrogeracao,
    criterioTipoModulo,
    criterioTipoInversor,
    criterioTipoOutros,
    criterioNovaUc,
    criterioUcInformada,
    criterioPotInstaMin500Kw,
    obrigPessoaFisica,
    obrigPessoaJuridica,
    obrigatorioTipoProjeto,
    extensoesValidas }) => {

    const [hasFileUploaded, setHasFileUploaded] = useState(false);
    const [tamanhoTexto, setTamanhoTexto] = useState("240px");

    useEffect(() => {
        const codigos = id.split('-');

        if (codigos[5] != 0) {
            codigoDocumento = codigos[5];
        }

        if (codigoDocumento !== 0) {
            setHasFileUploaded(true);
        }

    }, [codigoDocumento, id]);

    const isRequired =
        obrigatorio === 1 ||
        (obrigatorio === 2 &&
            (criterioAereo ||
                criterioSubterraneo ||
                criterioMinigeracao ||
                criterioMicrogeracao ||
                criterioTipoModulo ||
                criterioTipoInversor ||
                criterioTipoOutros ||
                criterioAutoConsumo ||
                criterioMultiUC ||
                criterioGeracaoComp ||
                criterioCompensacaoLocal ||
                criterioNovaUc ||
                criterioUcInformada ||
                criterioPotInstaMin500Kw ||
                obrigPessoaFisica ||
                obrigPessoaJuridica ||
                obrigatorioTipoProjeto
            )
        );

    useEffect(() => {
        if (isRequired) {
            origemSolicitacao ? setTamanhoTexto("210px") : setTamanhoTexto("160px")
        } else {
            origemSolicitacao ? setTamanhoTexto("300px") : setTamanhoTexto("250px")
        }
    }, [obrigatorio, origemSolicitacao]);

    return (
        <div className="uploads upload_box">
            <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                <Tooltip title={label}><p style={{ width: tamanhoTexto }}>{label}</p></Tooltip>
                {(isRequired) && <span style={{ color: "#ca463cff", fontSize: ".8rem", width: "200px" }}>* (Obrigatório)</span>}
                {(situacaoSolic === 2 && aprovado == 0) && <span style={{ color: "#ca463cff", fontSize: ".8rem", fontWeight: "bold", marginRight: "4px" }}>(Reprovado)</span>}
            </div>
            <input
                type="file"
                readOnly={disabled}
                id={id}
                className="upload_input"
                {...register(registerName)}
                onChange={(e) => handleUploadArquivos(e)}
                disabled={disabled || Boolean(aprovado)}
                accept={extensoesValidas}
            />
            <div style={{ display: "flex", width: "100%", maxHeight: "44px" }}>
                <Tooltip title={nomeArquivo ?? ""} placement="bottom">
                    <label
                        htmlFor={id}
                        className={`
        upload_label 
        ${hasFileUploaded ? 'uploaded_label' : ''} 
        ${Boolean(aprovado) ? 'check_aprovado' : ''}
        ${disabled ? 'upload_label_disabled' : ''}
    `}
                    >
                        {hasFileUploaded ? (nomeArquivo.length > 20 ? nomeArquivo.substring(0, 20).replace('.', '') + "..." : nomeArquivo) : "Selecione um arquivo"}
                    </label>
                </Tooltip>
                {aprovado && Boolean(aprovado) && situacaoSolic === 2 ? (
                    <>
                        {hasFileUploaded && (
                            <Tooltip title={"Realizar download do documento"} placement="bottom" >
                                <button className={`upload_button ${situacaoSolic === 2 && Boolean(aprovado) ? 'check_bg_aprovado' : ''}`} value={codigoDocumento} style={{ borderRadius: "0" }} onClick={handleDownloadArquivo}>
                                    <FontAwesomeIcon icon={faFileDownload} />
                                </button>
                            </Tooltip>
                        )}
                        <Tooltip title="Documento aprovado" placement="bottom">
                            <button
                                className="upload_button"
                                style={{ color: "green" }}
                                disabled
                            >
                                <FontAwesomeIcon icon={faCheck} />
                            </button>
                        </Tooltip>
                    </>

                ) : (
                    <>
                        <Tooltip title={"Realizar upload do documento"} placement="bottom" >
                            <button
                                className={`${hasFileUploaded ? 'upload_button_uploaded' : 'upload_button'}`}
                                style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                                onClick={(e) => {
                                    e.preventDefault();

                                    if (disabled) return;

                                    document.getElementById(id).click();
                                }}
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </Tooltip>

                        {hasFileUploaded && (
                            <Tooltip title={"Realizar download do documento"} placement="bottom" >
                                <button
                                    className={"upload_button_uploaded download"}
                                    value={codigoDocumento}
                                    data-codigo-id-doc={codigoIdDoc}
                                    onClick={handleDownloadArquivo}
                                >
                                    <FontAwesomeIcon icon={faFileDownload} />
                                </button>
                            </Tooltip>
                        )}

                        {hasFileUploaded && (
                            <Tooltip title={"Remover documento"} placement="bottom">
                                <button
                                    className="upload_button trash"
                                    value={codigoDocumento}
                                    data-codigo-id-doc={codigoIdDoc}
                                    disabled={disabled}
                                    style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                                    onClick={handleRemoverArquivo}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </Tooltip>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default UploadInput;